import api from '@/shared/api';
import type { AxiosResponse } from 'axios';

interface LoginCredentials {
  username: string;
  password: string;
  rememberMe: boolean;
}

interface LoginResponse {
  success: boolean;
  message?: string;
  mustChangePassword?: boolean;
  currentBranchId?: number;
}

interface SwitchBranchResponse {
  success: boolean;
  message: string;
}

interface ChangePasswordResponse {
  message: string;
  currentBranchId?: number;
}

class AuthApi {
  async login(credentials: LoginCredentials): Promise<AxiosResponse<LoginResponse>> {
    return api.post<LoginResponse>('/auth/login', credentials);
  }

  async logout(): Promise<AxiosResponse<{ message: string }>> {
    return api.post<{ message: string }>('/auth/logout');
  }

  async refreshToken(): Promise<AxiosResponse<void>> {
    return api.get('/auth/refresh');
  }

  async changePassword(data: { currentPassword: string; newPassword: string }): Promise<AxiosResponse<ChangePasswordResponse>> {
    return api.post<ChangePasswordResponse>('/auth/change-password', data);
  }

  async switchBranch(branchId: number): Promise<AxiosResponse<SwitchBranchResponse>> {
    return api.post<SwitchBranchResponse>('/auth/switch-branch', { branchId });
  }
}

export default new AuthApi();
